import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from "axios";
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import html2pdf from 'html2pdf.js/dist/html2pdf.bundle.min';
import { FaFilePdf } from 'react-icons/fa';

import { useSearchParams } from 'react-router-dom';
import HotelTabs from '../components/HotelTabs'; // Adjust path if different
import PackageBookingPopup from "../components/PackageBookingPopup";
import { useNavigate } from 'react-router-dom';


function PackageDetails() {
  const { id } = useParams();
  const [pkg, setPkg] = useState(null);
  const [hotels, setHotels] = useState([]);
  const [activeTab, setActiveTab] = useState('sightseeing');
  // const slider1 = useRef(null);
  // const slider2 = useRef(null);
  // const [nav1, setNav1] = useState(null);
  // const [nav2, setNav2] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);

  const [coupons, setCoupons] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [showCouponInput, setShowCouponInput] = useState(false);
  const [basePrice, setBasePrice] = useState(0);


  const [searchParams] = useSearchParams();
  const isWithFlight = searchParams.get('flight') === '1'; // true if flight=1
  const [activeRating, setActiveRating] = useState(3); // Default to 3-star

  useEffect(() => {
    axios
      .get("https://online.funforay.com/admin/api/coupons")
      .then((res) => {
        if (res.data.success) {
          setCoupons(res.data.data);
        }
      })
      .catch((err) => console.error("Coupon fetch error", err));
  }, []);
  const handleApplyCoupon = (coupon) => {
    if (!coupon) return;

    if (!coupon.status) {
      setCouponMessage("Coupon is inactive");
      return;
    }

    if (coupon.usage_limit && coupon.used >= coupon.usage_limit) {
      setCouponMessage("Coupon usage limit reached");
      return;
    }

    if (coupon.expiry_date && new Date(coupon.expiry_date) < new Date()) {
      setCouponMessage("Coupon expired");
      return;
    }

    let discount = 0;

    if (coupon.type === "fixed") {
      discount = Number(coupon.value);
    } else {
      discount = (basePrice * Number(coupon.value)) / 100;
    }

    discount = Math.min(discount, basePrice);

    setCouponCode(coupon.code);
    setDiscountAmount(discount);
    setIsCouponApplied(true);
    setCouponMessage("Coupon applied successfully");
  };
  const handleRemoveCoupon = () => {
    setCouponCode("");
    setDiscountAmount(0);
    setIsCouponApplied(false);
    setCouponMessage("");
  };
  const groupedHotels = {
    3: [],
    4: [],
    5: [],
  };

  hotels.forEach((hotel) => {
    if (hotel.rating === 3 || hotel.rating === 4 || hotel.rating === 5) {
      groupedHotels[hotel.rating].push(hotel);
    }
  });

  const firstHotelRating = pkg?.hotel_ratings?.[0];
  const firstRatingValue = firstHotelRating?.rating;
  const navigate = useNavigate();

  const handleDownload = async () => {
    const originalTab = activeTab;

    // Show all tab content temporarily
    setActiveTab('showAll');

    // Allow DOM to update before capturing
    await new Promise(resolve => setTimeout(resolve, 500));

    const element = document.getElementById('pdf-content');

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`${pkg?.title || 'package-details'}.pdf`);


    // Restore original tab
    setActiveTab(originalTab);
  };


  const handleShare = async (pdfUrl) => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Package Details',
          text: 'Here are the package details.',
          url: pdfUrl,
        });
      } else {
        // Fallback options
        const message = encodeURIComponent(
          `Here are the package details: ${pdfUrl}`
        );

        const whatsappURL = `https://wa.me/?text=${message}`;
        const emailURL = `mailto:?subject=Package Details&body=${message}`;

        const choice = prompt("Type 'w' for WhatsApp, 'e' for Email:");

        if (choice?.toLowerCase() === 'w') {
          window.open(whatsappURL, '_blank');
        } else if (choice?.toLowerCase() === 'e') {
          window.location.href = emailURL;
        }
      }
    } catch (error) {
      console.error('Share error:', error);
      alert('An error occurred while trying to share the PDF link.');
    }
  };


 const tabFields = [
  { key: 'sightseeing', label: 'Sightseeing', icon: 'tab1' },
  ...(isWithFlight ? [{ key: 'flights', label: 'Flights', icon: 'tab2' }] : []),
  { key: 'hotels', label: 'Hotels', icon: 'tab3' },
  { key: 'transfers', label: 'Transfers', icon: 'tab4' },
  { key: 'meals', label: 'Meals', icon: 'tab5' },
  { key: 'inclusions', label: 'Inclusions', icon: 'tab6' },
  { key: 'exclusions', label: 'Exclusions', icon: 'tab7' },
  { key: 'cancellation_policy', label: 'Cancellation Policy', icon: 'tab8' },
  { key: 'payment_terms', label: 'Payment Terms', icon: 'tab9' },
  { key: 'supplements', label: 'Supplements', icon: 'tab10' },
  { key: 'Additional Info', label: 'Additional Info', icon: 'tab11' },
];


  // useEffect(() => {
  //   setNav1(slider1.current);
  //   setNav2(slider2.current);
  // }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        const pkgRes = await fetch(`https://online.funforay.com/admin/api/packages/${id}`);
        const pkgData = await pkgRes.json();
        if (pkgData.success && pkgData.data) {
          setPkg(pkgData.data);
        }

        if (pkgData.data.hotels && Array.isArray(pkgData.data.hotels)) {
          const hotelIds = pkgData.data.hotels.map(id => `ids[]=${id}`).join('&');
          const hotelsRes = await fetch(`https://online.funforay.com/admin/api/hotels?${hotelIds}`);
          const hotelsData = await hotelsRes.json();
          if (hotelsData.success && hotelsData.data) {
            setHotels(hotelsData.data);
          }
        }

      } catch (err) {
        console.error('Error fetching data:', err);
      }
    }

    fetchData();
  }, [id]);

  if (!pkg) return <div>Loading...</div>;
  const images = pkg.images || [];

  // Price calculations
  let additionalPrice = 0;

  if (firstHotelRating?.room_types) {
    for (const room of firstHotelRating.room_types) {
      if (room.room_type?.toLowerCase() === 'double') {
        additionalPrice = Number(room.adults) || 0;
        break;
      }
    }
  }

  const withFlightBasePrice = Number(pkg.with_flight_regular_price) || 0;
  const withFlightTotalSalePrice = withFlightBasePrice + additionalPrice;


  let doublePrice = null;

  if (firstHotelRating?.room_types?.length) {
    const doubleRoom = firstHotelRating.room_types.find(
      rt => rt.room_type === "Double"
    );

    if (doubleRoom?.adults && doubleRoom.adults !== "N/A") {
      doublePrice = Number(doubleRoom.adults);
    }
  }

  return (
    <div id="pdf-content">
      <div className='package_title_section'>
        <div className='main_details_col infos_sec'>
          <div className='data'>
          <h2 className='pkgtitle'>
  {pkg.title}

  <span className='meta_item days_night'>
    {pkg.duration && !isNaN(pkg.duration)
      ? `${Number(pkg.duration)} Nights / ${Number(pkg.duration) + 1} Days`
      : 'Duration N/A'}
  </span>
</h2>
            <div className='package_meta_info'>


              <div className='meta_item'>
                {pkg.package_heading}
              </div>
              |
              <div className='meta_item'>

                {pkg.package_type}
              </div>
              |
              <div className='meta_item'>
                {pkg.package_format}
              </div>
              |
              <div className='meta_item'>
                {pkg.package_code}
              </div>
            </div>
          </div>
        </div>

        <div className='main_details_col bookbtn_section'>
          <div className='price_booknow_wrapper'>
            <p className='price_tag'>
              <span>Starting From</span>

              {/* Show different <del> price based on flight selection */}
              <del>
                ₹{isWithFlight
                  ? (pkg.sale_price + (withFlightBasePrice || 0))?.toLocaleString()
                  : pkg.sale_price?.toLocaleString()}
              </del>

              {/* Final price */}
              <span className='mainprice'>
                ₹{(isWithFlight ? withFlightTotalSalePrice : doublePrice)?.toLocaleString()}
              </span>
            </p>

            <button
              className="book_btn"
              onClick={() =>
                navigate("/package-booking", {
                  state: {
                    pkg,
                    isWithFlight,
                    withFlightTotalSalePrice,
                    doublePrice,
                    hotel_ratings: pkg?.hotel_ratings,
                  },
                })
              }
            >
              Book Now
            </button>


          </div>
        </div>

      </div>

      <div className='section_design'>
        <div className='main_data'>
          <div className='slider_part'>
            {images.length > 0 && (
              images.length === 1 ? (
                <img
                  src={`https://online.funforay.com/admin/storage/app/public/${images[0]}`}
                  alt="Package"
                  style={{
                    width: '100%',
                    height: '350px',
                    objectFit: 'cover',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                />
              ) : (
                <Slider
                  dots={true}
                  arrows={true}
                  infinite={true}
                  speed={500}
                  slidesToShow={1}
                  slidesToScroll={1}
                  autoplay={true}
                  autoplaySpeed={3000}
                >
                  {images.map((img, i) => (
                    <div key={i}>
                      <img
                        src={`https://online.funforay.com/admin/storage/app/public/${img}`}
                        alt={`Slide ${i}`}
                        style={{
                          width: '100%',
                          height: '350px',
                          objectFit: 'cover',
                          borderRadius: '10px',
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              )
            )}
          </div>


        </div>
        <div className="price_details">
          {pkg.hotel_ratings && pkg.hotel_ratings.length > 0 ? (
            pkg.hotel_ratings
              .filter(ratingGroup => ratingGroup.rating === firstRatingValue)
              .map((ratingGroup, index) =>
                ratingGroup.room_types
                  .filter(room => room.room_type === "Double")
                  .map((room, i) => (
                    <div key={i}>
                      {/* <div className="price_line">
                        <h4>Package Price</h4>
                        {room.adults && room.adults !== "N/A" && (
                          <p>Per Adult: <span>₹{Number(room.adults).toLocaleString()}</span></p>
                        )}
                        {room.cnb && room.cnb !== "N/A" && (
                          <p>CNB: <span>₹{Number(room.cnb).toLocaleString()}</span></p>
                        )}
                        {room.cwb && room.cwb !== "N/A" && (
                          <p>CWB: <span>₹{Number(room.cwb).toLocaleString()}</span></p>
                        )}
                        {room.infant && room.infant !== "N/A" && (
                          <p>Infant: <span>₹{Number(room.infant).toLocaleString()}</span></p>
                        )}
                      </div> */}

                      {/* PDF Buttons */}
                      <div className="pdf_buttons">
                        <h4>PDF File</h4>

                        <div style={{ display: 'flex', gap: '10px' }}>

                          <button
                            type="button"
                            onClick={() => {
                              const pdfUrl = `https://online.funforay.com/admin/package/${pkg.id}/download-pdf?flight=${isWithFlight ? 1 : 0}`;

                              const link = document.createElement("a");
                              link.href = pdfUrl;
                              link.setAttribute("download", "");
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                          >
                            <FaFilePdf style={{ marginRight: "6px" }} />
                            Download
                          </button>

                          <button
                            className="share"
                            onClick={() =>
                              handleShare(
                                `https://online.funforay.com/admin/package/${pkg.id}/download-pdf`
                              )
                            }
                          >
                            <FaFilePdf style={{ marginRight: '6px' }} />
                            Share
                          </button>

                        </div>
                      </div>

                      {/* Coupons Section */}
                    <div className="coupans detailscoupon">
  <h4 className="coupon_title">Coupons & Offers</h4>

  {/* AVAILABLE COUPONS */}
  <div className="coupon_list">
    {coupons
      ?.filter((c) => c.status)
      ?.slice(0, 2)
      ?.map((c, i) => {
        const isActive = couponCode === c.code;

        return (
          <div
            key={i}
            className={`coupon_card ${isActive ? "active" : ""}`}
          >
            <div className="coupon_left">
              <div className="coupon_icon">
  {c.type === "percentage" ? (
    <img src="/images/percent.png" alt="Percentage Icon" />
  ) : (
    <img src="/images/rupee-indian.png" alt="Rupee Icon" />
  )}
</div>

              <div className="coupon_content">
                <h5>{c.code}</h5>

                <p>{c.description}</p>
              </div>
            </div>

            <div className="coupon_right">
              <span className="coupon_discount">
                -
                {c.type === "percentage"
                  ? `${c.value}%`
                  : `₹${c.value}`}
              </span>

            
            </div>
          </div>
        );
      })}
  </div>

  {/* MESSAGE */}
  {couponMessage && (
    <p
      style={{
        color: isCouponApplied ? "green" : "red",
        marginTop: "10px",
        fontSize: "14px",
        fontWeight: "500",
      }}
    >
      {couponMessage}
    </p>
  )}
</div>

                    </div>
                  ))
              )
          ) : (
            <p>No hotel pricing available.</p>
          )}
        </div>

      </div>

      <div className='tabdata'>
        <div className="details_tabdesign">
          {tabFields.map((tab, index) => {
           const imgName = activeTab === tab.key
    ? `${tab.icon}-active-image.png`
    : `${tab.icon}-image.png`;
            return (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`details_tabdesign_btn ${activeTab === tab.key ? 'active' : ''}`}
              >
                <img src={`/images/${imgName}`} className='tab_image' alt={tab.label} />
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="tab_content">
          {activeTab === 'showAll' ? (
            <>
              {/* Flights */}
              {pkg.flights && (
                <>
                  <h3>Flights</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.flights }} />
                </>
              )}

              {/* Sightseeing */}
              {pkg.sightseeing && (
                <>
                  <h3>Sightseeing</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.sightseeing }} />
                </>
              )}

              {/* Hotels */}
              {hotels.length > 0 && <HotelTabs hotels={hotels} />}



              {/* Other Sections */}
              {pkg.transfers && (
                <>
                  <h3>Transfers</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.transfers }} />
                </>
              )}
              {pkg.meals && (
                <>
                  <h3>Meals</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.meals }} />
                </>
              )}
              {pkg.inclusions && (
                <>
                  <h3>Inclusions</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.inclusions }} />
                </>
              )}
              {pkg.exclusions && (
                <>
                  <h3>Exclusions</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.exclusions }} />
                </>
              )}
              {pkg.payment_terms && (
                <>
                  <h3>Payment Terms</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.payment_terms }} />
                </>
              )}
             
              {pkg.cancellation && (
                <>
                  <h3>Cancellation Policy</h3>
                  <div dangerouslySetInnerHTML={{ __html: pkg.cancellation }} />
                </>
              )}
            </>
          ) : activeTab === 'hotels' ? (
            hotels.length > 0 ? (
              <div>
                {(() => {
                  const grouped = { 3: [], 4: [], 5: [] };

                  hotels.forEach(hotel => {
                    let rating = parseInt(hotel.rating);
                    if (isNaN(rating) && typeof hotel.rating === 'string') {
                      rating = hotel.rating.split('★').length - 1;
                    }
                    if ([3, 4, 5].includes(rating)) {
                      grouped[rating].push(hotel);
                    }
                  });

                  const availableRatings = [3, 4, 5].filter(r => grouped[r]?.length > 0);

                  // ✅ prevent infinite re-render
                  if (!availableRatings.includes(activeRating) && availableRatings.length > 0) {
                    setTimeout(() => setActiveRating(availableRatings[0]), 0);
                  }

                  return (
                    <>
                      {/* ⭐ Rating Tabs */}
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                        {availableRatings.map((rating) => (
                          <button
                            key={rating}
                            onClick={() => setActiveRating(rating)}
                            style={{
                              padding: '10px 20px',
                              backgroundColor: activeRating === rating ? '#006CB8' : '#f0f0f0',
                              color: activeRating === rating ? '#fff' : '#000',
                              border: '1px solid #ccc',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '16px',
                            }}
                          >
                            {rating} Star
                          </button>
                        ))}
                      </div>

                      {/* ✅ Hotel Cards */}
                      <div className="hotel-cards">
                        {grouped[activeRating]?.map(hotel => {
                          let hotelImages = [];

                          try {
                            if (Array.isArray(hotel.images)) {
                              hotelImages = hotel.images;
                            } else if (
                              typeof hotel.images === 'string' &&
                              hotel.images.startsWith('[')
                            ) {
                              hotelImages = JSON.parse(hotel.images);
                            } else if (typeof hotel.images === 'string') {
                              hotelImages = hotel.images.split(',').map(img => img.trim());
                            }
                          } catch (e) {
                            console.warn('Image parse error', e);
                          }

                          hotelImages = hotelImages.filter(
                            img =>
                              img &&
                              img !== 'null' &&
                              img !== 'undefined' &&
                              img.trim() !== ''
                          );

                          return (
                            <div className="hotel-card" key={hotel.id}>

                              {/* 🔥 Slider FIXED */}
                              <div className="hotel-slider">
                                <Slider
                                  key={hotel.id} // ✅ FORCE RERENDER
                                  dots={false}
                                  arrows={true}
                                  infinite={hotelImages.length > 1}
                                  speed={500}
                                  slidesToShow={1}
                                  slidesToScroll={1}
                                >
                                  {hotelImages.length > 0 ? (
                                    hotelImages.map((img, i) => (
                                      <div key={i}>
                                        <img
                                          src={`https://online.funforay.com/admin/storage/app/public/${img}`}
                                          alt={hotel.name}
                                          className="hotel-img"
                                          onClick={() => {
                                            const fullImages = hotelImages.map(
                                              image =>
                                                `https://online.funforay.com/admin/storage/app/public/${image}`
                                            );
                                            setLightboxImages(fullImages);
                                            setPhotoIndex(i);
                                            setLightboxOpen(true);
                                          }}
                                        />
                                      </div>
                                    ))
                                  ) : (
                                    <div>
                                      <img
                                        src="https://placehold.co/600x400?text=No+Hotel+Image"
                                        alt="No Hotel"
                                        className="hotel-img"
                                      />
                                    </div>
                                  )}
                                </Slider>
                              </div>

                              {/* ✅ Info */}
                            <div className="hotel-info">
  <p className='hotel_city'>{hotel.city}</p>

  <h3 className='hotel_name'>
    {hotel.name}
  </h3>
</div>

                            </div>
                          );
                        })}
                      </div>
                    </>
                  );
                })()}
              </div>
            ) : (
              <p>No hotels available for this package.</p>
            )
          ) :

            (
    /* FIXED LOGIC START */
    (() => {
      // Map display keys to actual API property names
      const dataKey = activeTab === 'Additional Info' ? 'additional_info' : activeTab;
      
      return pkg[dataKey] ? (
        <div dangerouslySetInnerHTML={{ __html: pkg[dataKey] }} />
      ) : (
        <p>No {activeTab.replace('_', ' ')} information available.</p>
      );
    })()
    /* FIXED LOGIC END */
  )}
        </div>

      </div>

      <div className='Overview_design'>
        <h4 className='main_heading'>Overview</h4>
        <div dangerouslySetInnerHTML={{ __html: pkg.overview }} />
      </div>

      <div>
        <div dangerouslySetInnerHTML={{ __html: pkg.itinerary }} />
      </div>

     
      {lightboxOpen && (
        <Lightbox
          mainSrc={lightboxImages[photoIndex]}
          nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
          prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % lightboxImages.length)
          }
        />
      )}

    </div>

  );
};


const tableCellStyle = {
  border: '1px solid #ccc',
  textAlign: 'center',
  padding: '10px'
};

export default PackageDetails;